class TimeUtils {

    static getTimestamp() {
        return Date.now() / 1000;
    }

    static format(timestamp, showSeconds = true) {
        const minutes = parseInt(timestamp / 60);
        const hours = parseInt(minutes / 60);
        const seconds = timestamp % 60;

        if (showSeconds) {
            return `${hours}:${this.pad(minutes % 60)}:${this.pad(seconds)}`;
        } else {
            return `${hours}:${this.pad(minutes % 60)}`;
        }
    }

    static pad(number, width = 2) {
        number = number + '';
        return number.length >= width ? number : new Array(width - number.length + 1).join('0') + number;
    }
}

export default TimeUtils;